import fp1 from "../../assets/furniture-products/FP-1.png";
import fp2 from "../../assets/furniture-products/FP-2.png";
import fp3 from "../../assets/furniture-products/FP-3.png";
import fp4 from "../../assets/furniture-products/FP-4.png";
import fp5 from "../../assets/furniture-products/FP-5.png";
import fp6 from "../../assets/furniture-products/FP-6.png";
import fp7 from "../../assets/furniture-products/FP-7.png";
import fp8 from "../../assets/furniture-products/FP-8.png";
import fp9 from "../../assets/furniture-products/FP-9.png";
import fp10 from "../../assets/furniture-products/FP-10.png";
import fp12 from "../../assets/furniture-products/FP-12.png";
import fp13 from "../../assets/furniture-products/FP-13.png";
import fp14 from "../../assets/furniture-products/FP-14.png";
import fp15 from "../../assets/furniture-products/FP-15.png";
import fp16 from "../../assets/furniture-products/FP-16.png";
import fp17 from "../../assets/furniture-products/FP-17.png";
import fp18 from "../../assets/furniture-products/FP-18.png";
import fp19 from "../../assets/furniture-products/FP-19.png";
import fp20 from "../../assets/furniture-products/FP-20.png";
import fp21 from "../../assets/furniture-products/FP-21.png";
import fp22 from "../../assets/furniture-products/FP-22.png";
import fp23 from "../../assets/furniture-products/FP-23.png";

// Image imports

// Furniture products constant
const FurnitureProductsData = [
  {
    image: fp3,
    productHeader: "LED O.T. LIGHT",
    points: [
      "Salient Features : Extremely environment friendly with least energy consumption",
      "Considerable longer life to Halogen Bulbs",
      "Combination of yellow & White LEDs for optimum comfort to surgeon",
      "Shadow free uniform illustration inside cavities as well as open operating area",
      "Control of intensity by means of Digital Control Panels",
      "Easy Adjustment and focusing of light by steriliable handle",
      "Suitable for air movement produced by laminar air flow",
      "Most Comfortable for all major and multiple surgeries",
      "Light Intensity : <1,25,000 LUX",
      "LED’S Life : <40,000 Hours",
      " Color rendering index: <92",
      "Temperature increase: >2° C",
      "Color Temperature: 3500°- 6200°K",
      "Input Supply: AC 220-230 V/50 Hz",
    ],
  },
  {
    image: fp4,
    productHeader: "HALOGEN OT LIGHT",
    points: [
      "Available : Metal- Aluminium Dome, Dome Glass Reflector",
      "Bulb : Halogen: 24V X 150W",
      "Dual bulb –Switching over to another Bulb if the one is fail",
      "Not Certainty for Bulb life",
      "Light Intensity: 50,000 Lux in Aluminum Dome: Dome Glass Reflector: 85,000 Lux in Glass Reflector ",
    ],
  },
  {
    image: fp5,
    productHeader: "LED EXAMINATION LIGHT",
    points: [
      "Stand Model forwas Mobility",
      "Suitable for the best Examination and minor procedure",
      "Light Intensity:30,000 Lux",
    ],
  },
  {
    image: fp1,
    productHeader: "ICU BED",
    points: [
      "MS Powder coated structure with Perforated Top",
      "Two separate Screw for back rest Trendlenburg– reverse Trendlenburg",
      "Four Provisions for Saline Stand On Main Frame",
      "Overall Size: 84″ X 36″ X 24″ (without Hi-Lo Facilities)",
      "5″ Swiveling Castors : Regular/ PU (optional)",
      "Available with MS Bow- Lam panel, Fully SS Bow or ABS panel as per order",
      "Option supply: Side Railing, on bed Saline  stand, Mattress",
    ],
  },
  {
    image: fp6,
    productHeader: "RECOVERY BED",
    points: [
      "MS Powder coated structure with Perforated Top",
      "Two separate Screw for back rest Trendlenburg-reverse Trendlenburg",
      "Four Provisions for Saline Stand On Main Frame",
      "Overall Size: 84″ X 36″ X 24″ ",
      "Available with MS Bow- Lam panel, Fully SS Bow or ABS panel as per order",
      "Option supply: 5″ Swiveling Castors, Side Railing, onbed Saline stand, Mattress",
    ],
  },
  {
    image: fp7,
    productHeader: "FOLWER BED",
    points: [
      "MS Powder coated structure with Perforated Top",
      "Two separate Screw for back rest & Knee Rest",
      "Four Provisions for Saline Stand On Main Frame",
      "Overall Size: 84″ X 36″ X 24″ ",
      "Available with MS Bow- Lam panel, Fully SS Bow or ABS panel as per order",
      "Option supply: 5″ Swiveling Castors, Side Railing, on bed Saline stand, Mattress",
    ],
  },
  {
    image: fp8,
    productHeader: "SEMI FOLWER BED",
    points: [
      "MS Powder coated structure with Perforated Top",
      "Adjustable of Back Rest up to 85 Deg by means of screw",
      "Four Provisions for Saline Stand On Main Frame",
      "Overall Size: 78″ X36″ X24″ ",
      "Available with MS Bow- Lam panel, Fully SS Bow or ABS panel as per order",
      "Option supply: 5″ Swiveling Castors, Side Railing, on bed Saline stand, Mattress",
    ],
  },
  {
    image: fp9,
    productHeader: "PLAIN SHEET METAL BED",
    points: [
      "MS Powder coated structure with Perforated Top",
      "Four Provisions for Saline Stand On Main Frame",
      "Overall Size: 78″ X36″ X24″ ",
      "Available with MS Bow- Lam panel, Fully SS Bow or ABS panel as per order",
      "Option supply: 5″ Swiveling Castors, Side Railing, on bed Saline stand, Mattress",
    ],
  },
  {
    image: fp10,
    productHeader: " ATTENDANT BED",
    points: [
      "MS Powder coated structure with 2″Mattress",
      "Comfortable useful for visitors as well as attendant",
      "Overall size: 72″ X24″ X18″",
    ],
  },
  {
    image: fp12,
    productHeader: "TROMA CARE CRASH CART (EMERGENCY EQUIPMENT CART)",
    points: [
      "SS/MS tubular Framework-as per Requirement",
      "Six nos. Of removable multicolor bins",
      "Two lockable separate plastic storage uniteach having 3 drawers",
      "Top drawers having containers of different size",
      "5″/4″ (2+2) Swiveling Castors",
      "Pull out cardiac massage board above drawers",
      "Having SS Saline Road & MSPC Oregon Cylinder Holder on one Side",
      "Overbally Size: 950 mm X 500 mm X 1540mm +/-5%",
    ],
  },
  {
    image: fp13,
    productHeader: "MEDICINE DRUG INJECTION TROLLEY",
    points: [
      "Two lockable separate plastic storage unit each having 3 drawers",
      "MS Tubular Framework with two SS trays",
      "4″ Swiveling Castors",
    ],
  },
  {
    image: fp14,
    productHeader: "ECG MULTIPARA TROLLEY",
    points: [
      "Z shaped trolley with excellent look",
      "Three shelves with one drawer below top shelf",
      "2″ Swiveling Castors with easy mobility",
      "Overall size : 20″ X 15″ X 32 ″ ",
    ],
  },
  {
    image: fp15,
    productHeader: "INSTRUMENT TROLLEY",
    points: [
      "Trolley with MSPC as well as fully SS Structure",
      "SS Shelves along with SS Railing/ without Railing in MSPC",
      "Available size: 27″ X 18″ 32″ (2 wheel) and 36″ X 24″ X 32″ (4 wheel) ",
    ],
  },
  {
    image: fp16,
    productHeader: "OXYGEN CYLINDER TROLLEY",
    points: [],
  },
  {
    image: fp17,
    productHeader: "DRESSING TROLLEY",
    points: [
      " MSPC Structure with SSShelves along with SS Railing (2″ Wheel)",
      "Fully SS Structure with 4″Wheel",
      "Size : 27″ X 18″ X32″",
    ],
  },
  {
    image: fp18,
    productHeader: "MAYO'S TROLLEY",
    points: [
      "MSPC Structure with SS Tray & Frame",
      "Fully SS Structure",
      "Size : 17″ X 22″ –Adjustable height",
    ],
  },
  {
    image: fp19,
    productHeader: "LAPAROCOPY TROLLEY",
    points: [
      "Logically designed with visual height and comfortable size",
      "Monitor tray height: 54-46″",
      "Stuff size: 24″ X18″",
      "Powder coated with one lockable drawer-additional shelf",
      " Net Floor coverage : 28″X28″",
      "Electric panel with 6 Nos. 15/5 Amp. ISI marked plug - switches on the side of unit",
      "5″ Swiveling Castors two of them with brake.",
      "Provision for holding CO cylinder on the back of Unit  ensuring Stable mobility",
    ],
  },
  {
    image: fp20,
    productHeader: "REGULAR STRETCHER",
    points: [
      "MS Powder coated structure with ss handle",
      "Detachable top",
      "Overall size: 2030 mm X 600mm X 810mm",
      "Wheel Castors : 4″/ 6″/8″ as per confirmation.",
      "Optionally available: ss top",
    ],
  },
  {
    image: fp21,
    productHeader: "FOLDING STRETCHER",
    points: [
      "MS Powder coated structure with ss handle",
      "Detachable top",
      " Overall size: 2030 mm X 600mm X 810mm",
      "Wheel Castors : 4″/ 6″/8″ as per confirmation.",
      "Optionally available: ss top",
    ],
  },
  {
    image: fp2,
    productHeader: "EXAMINATION COUCH",
    points: [
      " MS Powder coated structure",
      "Perineal cut on leg side",
      "Overall size: 72″ X 24″ X32″",
      "Head portion of 18 adjustable on ratchet",
      "Optionally available: ss top and mattress",
    ],
  },
  {
    image: fp22,

    productHeader: "PLAIN COUCH",
    points: [
      "MS Powder coated structure",
      "Perineal cut on leg side",
      "Overall size: 72″ X 24″ X32″",
      "Head portion of 18 adjustable on ratchet",
      "Optionally available: ss top and mattress",
    ],
  },
  {
    image: fp23,
    productHeader: "PLAIN LABOR COUCH",
    points: [
      "MS Powder coated structure",
      "MSCP Liftotomy road with straps with Perineal cut on leg side",
      "Overall size: 72″ X 30″ X32″",
      "Optionally available: ss top and mattress",
    ],
  },
];

export const FurnitureProductsConstant = {
  dataFurnitureProducts: FurnitureProductsData,
};
